/**
 * How a candidate entered the Candidates panel. The buckets are mutually
 * exclusive and mirror the ladder in `ApplicantOriginChip.vue`, so a row's chip
 * always agrees with the bucket it was filtered into. Duplicated in
 * `ats-conversation` (no cheap `ats-interfaces` release) — keep both in sync.
 *
 * The ATS bucket is derived from `INTEGRATION_SOURCE_DISPLAY_NAMES`, so correct ATS
 * filtering also requires both repos to resolve the same `ats-interfaces` version.
 */
export enum CandidateOrigin {
  APPLICANT = 'APPLICANT',
  AI_SOURCED = 'AI_SOURCED',
  SOURCED = 'SOURCED',
  ATS = 'ATS',
}

export const CANDIDATE_ORIGIN_OPTIONS: Array<{ label: string; value: CandidateOrigin }> = [
  { label: 'Applicant', value: CandidateOrigin.APPLICANT },
  { label: 'AI Sourced', value: CandidateOrigin.AI_SOURCED },
  { label: 'Sourced', value: CandidateOrigin.SOURCED },
  { label: 'From ATS', value: CandidateOrigin.ATS },
];
